module.exports = __webpack_public_path__ + "static/media/grad1.a5d7d8a7.PNG";